import {createSelector} from 'reselect';

const selectLayout = state => state.Layout;

export const selectLayoutType = createSelector(
    [selectLayout],
    layout => layout.layoutType,
);